<template>
  <div class="dialog_detail">
    <mt-popup v-model="isVisible" popup-transition="popup-fade" :closeOnClickModal="true">
      <div class="popup-header align-center">
        商品详情
      </div>
      <div class="popup-body">
        <img v-for="(img,index) in $store.state.userInfo.currentProduct.covers" :key="index" :src="img" alt="">
      </div>
      <!-- <div class="popup-footer align-center">
              </div> -->
      <button type="button" class="btn-close" @click="$store.dispatch('dialogVisible', { name: dialogName, visible: false })"></button>
    </mt-popup>
  </div>
</template>

<script>
export default {
  name: 'dialog_detail',
  data () {
    return {
      dialogName: 'detail'
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.$store.state.dialogVisible[this.dialogName]
      },
      set (value) {
        this.$store.dispatch('dialogVisible', { name: this.dialogName, visible: value })
      }
    }
  },
  methods: {

  },
  created () {

  },
  mounted () {

  },
  components: {
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/variable.less";
@import "../assets/less/function_px.less";
.mint-popup {
  width: 90%;
  max-height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  background-color: #fff;
  border-radius: 5px;
  margin-top: -20px;
  .popup-header {
    flex: 0 0 auto;
    border-radius: 5px 5px 0 0;
    height: 60px;
    background: @c_btn_linear;
    font-size: 20px;
    line-height: 60px;
    text-align: center;
    color: #fff;
  }

  .popup-body {
    flex: 1 1 auto;
    border-radius: 0 0 5px 5px;
    min-height: 100px;
    overflow: auto;
    background-color: #fff;
    padding: 15px 5px;
    -webkit-mask: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 10px,
      rgba(0, 0, 0, 1) 30px,
      rgba(0, 0, 0, 1) calc(~"100% - 30px"),
      rgba(0, 0, 0, 0) calc(~"100% - 10px")
    );
    img {
      width: 100%;
      display: block;
    }
  }
  .popup-footer {
    flex: 0 0 auto;
    padding: 10px;
  }
  .btn-close {
    .bgImg( "../../assets/images/sprites/dialog_close.png", 0.5);
    .bgSprite(h);
    bottom: -40px;
  }
}
</style>
